import { useMemo, type ReactNode } from "react";
import { Libelles } from "@dozka/ui";
import { useTranslation } from "react-i18next";

import { libellesDeLApp } from "./motsDeLaLibrairie";

/**
 * Pose `<Libelles>` UNE fois, à la racine de l'app (`AppProviders`), avec les mots de la
 * librairie dans la langue courante : « Fermer », « Annuler », la pagination, le `Tableau`,
 * le `Delta`. Les tables et leur règle sont dans `motsDeLaLibrairie.ts`.
 */
export function LibellesDeLApp({ children }: { children: ReactNode }) {
  const { t, i18n } = useTranslation();
  const langue = i18n?.resolvedLanguage ?? "fr";
  const valeurs = useMemo(() => libellesDeLApp(langue, t), [langue, t]);
  return <Libelles valeurs={valeurs}>{children}</Libelles>;
}
